function adicionarHoverNoLink(li) {
  const aPrincipal = li.querySelector(':scope > a');
  if (aPrincipal) aPrincipal.classList.add('nav-item-hover');
}

function removerHoverDoLink(li) {
  if (li.classList.contains('menu-ativo')) return;
  const aPrincipal = li.querySelector(':scope > a');
  if (aPrincipal) aPrincipal.classList.remove('nav-item-hover');
}

document.querySelectorAll('#side-menu > li, .main-menu > li').forEach(li => {
  li.addEventListener('mouseenter', () => adicionarHoverNoLink(li));
  li.addEventListener('mouseleave', () => removerHoverDoLink(li));
});

const menuTransmissao = document.querySelector('#menu-transmissao-marketing');
if (menuTransmissao) {
  const dataInicialStr = menuTransmissao.dataset.dataInicial;
  const dataFinalStr = menuTransmissao.dataset.dataFinal;
  const dataInicial = Date.parse(dataInicialStr);
  const dataFinal = Date.parse(dataFinalStr);

  const agora = Date.now();
  const menuParceiros = document.querySelector('#menu-parceiros');
  const presentinho = document.querySelector('#presentinho');

  if (!isNaN(dataInicial) && !isNaN(dataFinal)) {
    if (agora >= dataInicial && agora <= dataFinal) {
      menuTransmissao.style.display = '';
      if (menuParceiros) menuParceiros.style.display = 'none';
      if (presentinho) presentinho.style.display = 'none';
    } else {
      menuTransmissao.style.display = 'none';
      if (menuParceiros) menuParceiros.style.display = '';
      if (presentinho) presentinho.style.display = '';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.items-menu > li').forEach(li => {
    li.classList.remove('menu-ativo');
  });

  const linksAtivos = Array.from(document.querySelectorAll(`.items-menu a[href="${window.location.pathname}"]`));
  linksAtivos.forEach(link => {
    const liGrupo = link.closest('.items-menu > li');
    if (liGrupo) {
      liGrupo.classList.add('menu-ativo');
      adicionarHoverNoLink(liGrupo);
    }
  });
});
